import { baseUrl, handleResponse, handleError, GetHeaders, PutOptions } from "../common/ApiUtils";

const apiUrl = baseUrl + "Utilities/";

export function getUserProfile() {
  return fetch(apiUrl + "profile/", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function setThemeSetting(settings) {
  return fetch(apiUrl + "settings", PutOptions(settings))
    .then(handleResponse)
    .catch(handleError);
}
